/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { InlineMessage, SubPage, Group, Copy, Title, Link, ListTable } from '@insticator/insticator-ui'; // iui-materials
//styles
// import injectSheet from 'react-jss';
// import styles from 'pages/dashboard/account/sites/sites_styles';



/* ========== ~~~~~~~~~~ ACCOUNT SITES ~~~~~~~~~~ ========== */
class Sites extends Component {
    handleRenderSites = () => {
        let sites =[];
        Object.keys(this.props.sites).forEach(item => sites.push({ name: <Link type={`external`} text={`${this.props.sites[item]}`} color={`primary`} action={`http://${this.props.sites[item]}`} /> }));
        return sites;
    };
    render() {
        return(
            <SubPage name={`sites`}>
                <Copy name={`page-copy`}>
                    <Title>
                        <h2>Sites</h2>
                    </Title>
                </Copy>
                <Group name={`page-details`}>
                    <InlineMessage variant={`neutral`} size={`full`} icon={`exclamation-triangle`} message={<span>If you want to add a site to your account, please email your Account Manager or email <Link type={`email`} text={`support@insticator.com`} color={`primary`} action={`mailto:support@insticator.com`} /></span>} />
                    { !!Object.keys(this.props.sites).length && <ListTable
                        name={`sites`}
                        type={`basic`}
                        size={`full`}
                        columnHeads={{ name: 'Name' }}
                        data={this.handleRenderSites()}
                        rowsPerPage={'general'}
                        paginationLocation={`bottom`}
                    />}
                </Group>
            </SubPage>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Sites;
// export default injectSheet(styles)(Sites);
